import axios from 'axios'

const apiUrl = process.env.API_URL

const waitingListCountEndpoint = '/waiting-list/count/'
const waitingListPostEndpoint = '/waiting-list'
const waitingListReferralCountEndpoint = '/waiting-list/referral-count'
const blogPostsEndpoint = '/blog/posts'

export const getWaitingListCount = () => {
  return axios.get(`${apiUrl}${waitingListCountEndpoint}`).then(response => response.data)
}

export const postToWaitingList = (email, forename, surname, referrer) => {
  return axios.post(`${apiUrl}${waitingListPostEndpoint}`, {
    email: email,
    forename: forename,
    surname: surname,
    referrer: referrer
  }).then(response => response.data)
}

export const trackMyReferrals = (email, referralCode) => {
  return axios.post(`${apiUrl}${waitingListReferralCountEndpoint}`, {
    email: email,
    referralCode: referralCode
  }).then(response => response.data)
}

export const getBlogPosts = () => {
  return axios.get(`${apiUrl}${blogPostsEndpoint}`).then(response => response.data)
}



// WEBPACK FOOTER //
// ./src/api/index.js